import { takeEvery, put, fork, call } from "redux-saga/effects";
import * as actions from "../actions/SparePartActions";
import * as api from "../../api/SparePartApi";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
} from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getSparePartList({ payload }) {
  yield put(resetBackdrop());
  try {
    const { data } = yield call(api.getSparePartList, payload);
    yield put(actions.setSparePartList(data || undefined));
  } catch (error) {
    console.error("getSparePartList saga error:", error);
    yield put(actions.setSparePartList(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* getSparePartUsageList({ payload }) {
  yield put(resetBackdrop());
  try {
    const { data } = yield api.getSparePartUsageList(payload);
    yield put(actions.setSparePartUsageList(data || undefined));
  } catch (error) {
    yield put(actions.setSparePartUsageList(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* getSparePartUsagePlannedList({ payload }) {
  yield put(resetBackdrop());
  try {
    const { data } = yield api.getSparePartUsagePlannedList(payload);
    yield put(actions.setSparePartUsagePlannedList(data || undefined));
  } catch (error) {
    yield put(actions.setSparePartUsagePlannedList(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* getSelectedSparePartList(action) {
  try {
    console.log("action", action.payload.type);
    if (action.payload.type === "breakdown") {
      const { data } = yield api.getSelectedSparePartListUnplanned(
        action.payload.taskId
      );
      yield put(actions.setSelectedSparePartList(data || undefined));
    } else {
      const { data } = yield api.getSelectedSparePartListPlanned(
        action.payload.taskId
      );
      console.log("data", data);
      yield put(actions.setSelectedSparePartList(data || undefined));
    }
  } catch (error) {
    yield put(actions.setSelectedSparePartList(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* addSparePart(action) {
  console.log("action", action);
  yield put(resetBackdrop());
  try {
    const data = yield api.addSparePart(action.payload);
    yield put(actions.addSparePartRes(data || undefined));
    yield put(showSuccessSnackbar(data));
  } catch (error) {
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* addSparePartNote(action) {
  yield put(resetBackdrop());
  let payload = {
    pageNumber: 1,
    pageSize: 10,
    searchText: ""
  };
  try {
    yield api.addSparePartNote(action.payload);
    const { data: sparePartNoteData } = yield api.getSparePartNoteList(payload);
    yield put(actions.setSparePartNoteList(sparePartNoteData || undefined));
  } catch (error) {
    const { data: sparePartNoteData } = yield api.getSparePartNoteList(payload);
    yield put(actions.setSparePartNoteList(sparePartNoteData || undefined));
    yield put(showErrorSnackbar(error));
  }
}

function* updateSparePart(action) {
  yield put(resetBackdrop());
  try {
    const data = yield api.updateSparePart(action.payload);
    yield put(showSuccessSnackbar(data));
    yield put(
      actions.getSparePartList({
        currentPage: 1,
        pageSize: 10,
        searchText: "",
        propertyName: "",
        direction: 1,
      })
    );
    yield put(actions.updateSparePartSuccess(data));
  } catch (error) {
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* updateSparePartNote(action) {
  yield put(resetBackdrop());
  let payload = {
    pageNumber: 1,
    pageSize: 10,
    searchText: ""
  };
  try {
    const { data } = yield api.updateSparePartNote(action.payload);
    yield put(showSuccessSnackbar("Note updated successfully!"));
    const { data: sparePartNoteData } = yield api.getSparePartNoteList(payload);
    yield put(actions.setSparePartNoteList(sparePartNoteData || undefined));

  } catch (error) {
    yield put(showErrorSnackbar(error));
    const { data: sparePartNoteData } = yield api.getSparePartNoteList(payload);
    yield put(actions.setSparePartNoteList(sparePartNoteData || undefined));
  }
  yield put(setBackdrop());
}


function* deleteSparePart(action) {
  yield put(resetBackdrop());
  try {
    const data = yield api.deleteSparePart(action.payload);
    yield put(actions.deleteSparePartRes(data || undefined));
    yield put(actions.resetDelSp());
    yield put(showSuccessSnackbar(data));
  } catch (error) {
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* deleteSparePartNote(action) {
  yield put(resetBackdrop());

  try {
    const response = yield api.deleteSparePartNote(action.payload);
    const data = response.data;

    if (data?.success) {
      yield put(actions.setSparePartNoteDelete(action.payload));
      let payload = {
        pageNumber: 1,
        pageSize: 10,
        searchText: ""
      };
      const { data: sparePartNoteData } = yield api.getSparePartNoteList(payload);
      yield put(actions.setSparePartNoteList(sparePartNoteData || undefined));
      yield put(showSuccessSnackbar(data.message));
    } else {
      yield put(actions.setSparePartNoteDelete(undefined));
      yield put(showErrorSnackbar(data?.message || "Delete failed"));
    }
  } catch (error) {
    yield put(actions.setSparePartNoteDelete(undefined));
    yield put(showErrorSnackbar(error.message || "Delete failed"));
  }
}

function* getSparePartLogList({ payload }) {
  yield put(resetBackdrop());
  try {
    const { data } = yield api.getSparePartLogList(payload);
    yield put(actions.setSparePartLogList(data || undefined));
  } catch (error) {
    yield put(actions.setSparePartLogList(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* getSparePartNoteList(payload) {
  yield put(resetBackdrop());
  try {
    const { data } = yield api.getSparePartNoteList(payload);
    yield put(actions.setSparePartNoteList(data || undefined));
  } catch (error) {
    yield put(actions.setSparePartNoteList(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* getPoolList(action) {
  try {
    const { data } = yield api.getPoolList(action.payload);
    yield put(actions.setPoolList(data || undefined));
  } catch (error) {
    yield put(actions.setPoolList(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}
function* saveSparePart({ payload }) {
  yield put(resetBackdrop());
  const sparePartPayload = {
    currentPage: 1,
    pageSize: 10,
    searchText: "",
    propertyName: "",
    direction: 1,
  };
  try {
    if (payload.type === "breakdown") {
      const { data } = yield api.saveSparePartBreakdown(payload);
      yield put(showSuccessSnackbar(data.message));
      yield put(actions.getSparePartList(sparePartPayload));
    } else {
      const { data } = yield api.saveSparePartPlanned(payload);
      yield put(actions.getSparePartList(sparePartPayload));
      yield put(showSuccessSnackbar(data.message));
    }
  } catch (error) {
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* getListStockCodesAndMaterialDescriptions(action) {
  try {
    const { data } = yield api.getListStockCodesAndMaterialDescriptions(
      action.payload
    );
    yield put(
      actions.setListStockCodesAndMaterialDescriptions(data || undefined)
    );
  } catch (error) {
    yield put(actions.setListStockCodesAndMaterialDescriptions(undefined));
    yield put(showErrorSnackbar(error));
  }
  yield put(setBackdrop());
}

function* watchAll() {
  yield takeEvery(actions.Types.GET_SPARE_PART_LIST, getSparePartList);
  yield takeEvery(actions.Types.GET_SPARE_PART_LOG_LIST, getSparePartLogList);

  yield takeEvery(actions.Types.GET_POOL_LIST_FOR_SPARE_PART_LIST, getPoolList);
  yield takeEvery(
    actions.Types.GET_SPARE_PART_USAGE_LIST,
    getSparePartUsageList
  );
  yield takeEvery(
    actions.Types.GET_SPARE_PART_USAGE_PLANNED_LIST,
    getSparePartUsagePlannedList
  );
  yield takeEvery(
    actions.Types.GET_SELECTED_SPARE_PART_LIST,
    getSelectedSparePartList
  );
  yield takeEvery(
    actions.Types.GET_LIST_STOCK_CODES_AND_MATERIAL_DESCRIPTIONS,
    getListStockCodesAndMaterialDescriptions
  );
  yield takeEvery(actions.Types.SAVE_SPARE_PART, saveSparePart);
  yield takeEvery(actions.Types.ADD_SPARE_PART, addSparePart);
  yield takeEvery(actions.Types.UPDATE_SPARE_PART, updateSparePart);
  yield takeEvery(actions.Types.DELETE_SPARE_PART, deleteSparePart);
  yield takeEvery(actions.Types.GET_SPARE_PART_NOTE_LIST, getSparePartNoteList);
  yield takeEvery(actions.Types.ADD_SPARE_PART_NOTE, addSparePartNote);
  yield takeEvery(actions.Types.UPDATE_SPARE_PART_NOTE, updateSparePartNote);
  yield takeEvery(actions.Types.DELETE_SPARE_PART_NOTE, deleteSparePartNote);
}

const SparePartSaga = [fork(watchAll)];

export default SparePartSaga;
